export default __webpack_public_path__ + "static/media/specieslistprologo.6abf42e5.png";